import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Calculator } from "lucide-react";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import { services } from "../mock";
import { iconMap } from "../lib/iconMap";

export default function Services() {
  return (
    <div>
      <PageHeader
        title="Our Services"
        crumb="Services"
        subtitle="From transformative innovation to transactional management, we cover every stage of your B-BBEE journey with distinct and diverse capabilities."
      />

      {/* Intro */}
      <section className="py-16">
        <div className="container-x max-w-3xl text-center">
          <Reveal>
            <div className="eyebrow justify-center mb-4" style={{ display: "inline-flex" }}>What We Do</div>
            <p className="text-slate-600 leading-relaxed text-lg">
              Our range of services stems from our background in strategy consulting and encompasses a wide
              array of offerings. With our distinct and diverse capabilities, we are dedicated to assisting you
              at every stage of your Broad-Based Black Economic Empowerment journey.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Services alternating rows */}
      <section className="pb-10">
        <div className="container-x space-y-16">
          {services.map((s, idx) => {
            const Icon = iconMap[s.icon];
            const flip = idx % 2 === 1;
            return (
              <Reveal key={s.slug}>
                <div className="grid lg:grid-cols-2 gap-10 items-center">
                  <div className={`rounded-2xl overflow-hidden shadow-[0_30px_60px_-30px_rgba(10,26,52,.45)] ${flip ? "lg:order-2" : ""}`}>
                    <img src={s.image} alt={s.title} className="w-full h-[320px] object-cover" />
                  </div>
                  <div className={flip ? "lg:order-1" : ""}>
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-14 h-14 rounded-xl bg-[#0B1F3A] grid place-items-center text-[#D4AF37]">
                        <Icon size={26} />
                      </div>
                      <span className="text-sm font-semibold tracking-wide uppercase text-[#184E9E]">
                        0{idx + 1}
                      </span>
                    </div>
                    <h2 className="font-head text-2xl md:text-3xl font-bold text-[#0B1F3A]">{s.title}</h2>
                    <p className="mt-4 text-slate-600 leading-relaxed">{s.long}</p>
                    <div className="mt-6 flex flex-wrap gap-3">
                      <Link to="/pricing-calculator" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-lg">
                        <Calculator size={17} /> Get a Quote
                      </Link>
                      <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-slate-200 text-[#0B1F3A] font-semibold hover:border-[#D4AF37] transition-colors">
                        Enquire <ArrowRight size={16} />
                      </Link>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* Process */}
      <section className="py-20 md:py-24 bg-[#F6F7F9] mt-10">
        <div className="container-x">
          <Reveal className="text-center max-w-2xl mx-auto mb-14">
            <div className="eyebrow justify-center mb-4" style={{ display: "inline-flex" }}>How We Work</div>
            <h2 className="font-head text-3xl md:text-4xl font-bold text-[#0B1F3A]">A Clear, Proven Approach</h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { n: "01", t: "Discover", d: "We understand your business, sector and current B-BBEE standing." },
              { n: "02", t: "Analyse", d: "A full gap analysis identifies risks and quick-win opportunities." },
              { n: "03", t: "Strategise", d: "We build a tailored, cost-effective transformation plan." },
              { n: "04", t: "Implement", d: "We guide execution and prepare you for verification success." },
            ].map((step, idx) => (
              <Reveal key={step.n} delay={idx * 90}>
                <div className="card-lift bg-white rounded-2xl p-7 border border-slate-100 h-full">
                  <div className="font-head text-3xl font-extrabold text-[#D4AF37]/40">{step.n}</div>
                  <h3 className="font-head font-semibold text-lg text-[#0B1F3A] mt-2 mb-2">{step.t}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed">{step.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16">
        <div className="container-x text-center">
          <h2 className="font-head text-2xl md:text-3xl font-bold text-[#0B1F3A] max-w-2xl mx-auto">
            Ready to see what your B-BBEE consulting would cost?
          </h2>
          <Link to="/pricing-calculator" className="btn-gold inline-flex items-center gap-2 px-7 py-3.5 rounded-lg mt-6">
            <Calculator size={18} /> Get Instant Quote
          </Link>
        </div>
      </section>
    </div>
  );
}
